import React, {useEffect, useState} from "react";
import { useIntl } from 'react-intl';

// Components
import { Form } from 'Components';
import Slider from 'Components/Slider';
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";
import {Grid} from "@mui/material";


export const Stationary = (props) => {

    const { value, onChange, formRef, triggers, triggersRaw } = props
    const { messages } = useIntl()
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

    useEffect(() => {
        if (value.triggerDuration == undefined)
            onChange({
                ...value,
                triggerDuration: {
                    duration: 'Days',
                    value: 1,
                },
            })
    }, [value])

    return (
        <Form ref={formRef}
              onSubmit={() => {
                  if (value.trigger) {
                      let isValid = triggersRaw?.length > 0

                      if (!isValid) {
                          setShowErrorTrigger(true)
                      } else setShowErrorTrigger(false)
                      return isValid
                  }
              }}
        >
            {
                value.triggerDuration != undefined &&

                <div className="form-item" style={{padding: "20px 0"}}>
                    <label className="input-normal-label">{messages['alertsNewAlert_Parameters']}</label>
                    <div style={{width: '100%', marginTop: 10, marginBottom: 20}}>
                        <>
                            <label className="input-normal-label">{messages['alertsNewAlert_Over']}</label>
                            <Slider
                                min={1}
                                max={60}
                                value={value.triggerDuration.value}
                                onChange={(event) => {

                                    onChange({
                                        ...value, triggerDuration: {
                                            value: event,
                                            duration: value.triggerDuration.duration,
                                        }
                                    });
                                }}
                                sliderOneColor={false}
                                showValue
                                valueLabelDisplay={'off'}
                                measure={messages['alert_daysLabel']}
                            />
                        </>
                    </div>

                    <div>
                        <TriggerLandmark config={value} triggers={triggers} triggersRaw={triggersRaw} onChange={onChange} showErrorTrigger={showErrorTrigger}/>
                    </div>
                </div>
            }
        </Form>
    );
}
